import { useEffect, useRef, useState } from 'react';
import BaseModal from '../../../components/Modals/BaseModal';
import { EventRequest, EventStatus } from '../../../interfaces/events';
import { getZeroCostWarning } from '../utils/zeroCostWarning';

const useZeroCostConfirmation = (onEdit?: () => void) => {
  const [warning, setWarning] =
    useState<ReturnType<typeof getZeroCostWarning>>();
  const pending = useRef<((confirmed: boolean) => void) | null>(null);

  useEffect(() => () => {
    pending.current?.(false);
    pending.current = null;
  }, []);

  const finish = (confirmed: boolean) => {
    const resolve = pending.current;
    pending.current = null;
    setWarning(undefined);
    resolve?.(confirmed);
  };

  const confirmZeroCosts = (
    event: EventRequest,
    status?: EventStatus,
    includeHeadquarterCosts = false,
  ): Promise<boolean> => {
    if (pending.current) return Promise.resolve(false);

    const nextWarning = getZeroCostWarning(event, status, includeHeadquarterCosts);
    if (!nextWarning) return Promise.resolve(true);

    return new Promise((resolve) => {
      pending.current = resolve;
      setWarning(nextWarning);
    });
  };

  const edit = () => {
    finish(false);
    onEdit?.();
  };

  const zeroCostModal = (
    <BaseModal
      isOpen={!!warning}
      title='Verifica dei costi a 0 €'
      toggle={() => finish(false)}
      onCancel={edit}
      onConfirm={() => finish(true)}
      confirmButtonText='Procedi'
      cancelButtonText='Modifica'
    >
      <div className='space-y-4 text-gray-700'>
        <p>Attenzione: le seguenti voci di costo sono valorizzate 0 €</p>
        <ul className='list-disc pl-6'>
          {warning?.labels.map((label) => <li key={label}>{label}</li>)}
        </ul>
        <p>Vuoi procedere comunque con la {warning?.action}?</p>
      </div>
    </BaseModal>
  );

  return { confirmZeroCosts, zeroCostModal };
};

export default useZeroCostConfirmation;
